export default {
    AREA_SIGN: 'outer',
    //总片区
    URL_SERVICE_ACCOUNT_MAIN: 'https://user0-web.zdian-e.com/service/accountservice',
    //子片区
    URL_SERVICE: 'https://user1-web.zdian-e.com/service',
    URL_SERVICE_MAINSERVICE: 'https://user1-web.zdian-e.com/service/mainservice'
}